
import JoinCommunityCta from '~/components/community/JoinCommunityCta.vue';
import NewsletterSignupInput from '~/components/generic/NewsletterSignupInput.vue';
import CommunityIntro from '~/components/page-components/communitypage/CommunityIntro.vue';
import MemberList from '~/components/page-components/communitypage/MemberList.vue';

export default {
  components: { CommunityIntro, MemberList, JoinCommunityCta, NewsletterSignupInput },
  data () {
    return {
      email: '',
      loading: false,
      success: false
    };
  },
  computed: {
    validEmail () {
      return /\S+@\S+\.\S+/.test(this.email);
    }
  },
  mounted () {
    this.$store.commit('closeMenu');
  },
  methods: {
    async signupToNewsletter () {
      try {
        this.loading = true;
        const payload = {
          email: this.email
        };
        await this.$axios.$post('api/newsletter/signup', payload);
        // console.info(res);
        this.success = true;
      } catch (err) {
        // console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }

};
